import { Loader } from "@googlemaps/js-api-loader";

export default function(el) {
    const mapContainer = el.querySelector(".mcm__map");
    const mapId = "d6b5f22e2c2adecc"; // Styled map ID

    const getZoom = () => {
        const zoom = parseInt(el.dataset.zoom, 10);

        return !zoom ? 13 : zoom; // If we cant get zoom return 13 as a default zoom
    };

    const getCoordinates = () => {
        const lat = parseFloat(el.dataset.lat);
        const lng = parseFloat(el.dataset.lng);

        if (!lat || !lng) return;

        return { lat, lng };
    };

    const coordinates = getCoordinates();
    const zoom = getZoom();

    if (!mapContainer || !coordinates) return;

    const loader = new Loader({
        apiKey: "AIzaSyB90CKaigozFZFKhsVuc1Za4t9g8WFVljY",
        mapIds: [mapId], // Fetch styled map
        version: "weekly",
    });

    loader.load().then(() => {
        const map = new google.maps.Map(mapContainer, {
            center: coordinates,
            disableDefaultUI: true,
            zoom,
            mapId, // Use styled map
        });

        const marker = new google.maps.Marker({
            position: coordinates,
            map: map,
        });
    });
}
